var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-parlay"},[(_vm.isPremiumUser)?_c('ParlayPremium'):_c('ParlayFree')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }